import React from "react";
import { ResponsiveContainer, Brush, LineChart,Tooltip,CartesianGrid, Line, XAxis, YAxis} from "recharts";


const About = (props) => {
  const data = props.portfolioData;
    return (
      <section className="site-section site-standard" id="skills">
      <div className="container">
      <div className="site-section__icon">
          <hr className="progress"></hr>
        </div>
      <div className="site-section__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="33" height="7" viewBox="0 0 73.94 14.19">
            <polyline points="2.83 2.83 11.36 11.36 19.9 2.83 28.43 11.36 36.97 2.83 45.5 11.36 54.04 2.83 62.58 11.36 71.11 2.83" style={{ strokeDashoffset: "2e-05", strokeDasharray: "2e-05" }}></polyline>
          </svg>
        </div>
        <h1 className="site-heading">Skills</h1>
        <div className="row" >
    <React.Fragment>
      <ResponsiveContainer width="95%" aspect={3} >
       <LineChart data= {data.simpleData} isAnimationActive={false}>
        
         <XAxis dataKey ="language" fontSize={14} stroke="#ffffff"/>
         <Line type="natural" dataKey="percentage" stroke="#ee82ee"/>
         <YAxis stroke="#ffffff"/>
         <Tooltip isAnimationActive={true} animationEasing="ease-in-out" />
         <CartesianGrid strokeDasharray="3 3" opacity={0.2} stroke="#ee82ee"/>
       </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
    </div></div>
    </section>
    );
};

export default About;